import { createSyncAction } from '@bimser/core';
import * as ActionTypes from './actionTypes';
import {
	IWebInterfaceAction,
	WebInterfaceActionFactoryFromJS
} from '../entities/IWebInterfaceAction';

export default function panelListSelectedDataChangeTransaction(data: IWebInterfaceAction) {
	if (!data) {
		return undefined;
	}
	const payload = WebInterfaceActionFactoryFromJS(data);
	const action = createSyncAction(
		ActionTypes.PANEL_LIST_SELECTED_DATA_ONCHANGE_TRANSACTION,
		payload
	);
	return action;
}
